export const FORM_NAME = 'ClientRiskLevelModalForm'
export const MODAL_NAME = 'ClientRiskLevelModal'
